export default {
  article_breadcrumb_home: 'Strona główna',
  article_breadcrumb_current: 'Poradnik USFans Spreadsheet',
  article_category: 'Poradniki',
  article_reading_time: '8 min czytania',
  article_updated: 'Zaktualizowano',
  article_title: 'Poradnik USFans Spreadsheet: co to jest i jak z niego korzystać',
  article_lead:
    'USFans Spreadsheet to prosty, uporządkowany sposób na organizowanie i badanie informacji o produktach, sprzedawcach i zasobach. Ten poradnik wyjaśnia, czym jest, dlaczego się go używa i jak najlepiej z niego korzystać — krok po kroku.',

  article_h2_1: 'Czym jest USFans Spreadsheet?',
  article_p_1:
    'USFans Spreadsheet to uporządkowany sposób na organizowanie i badanie informacji o produktach, sprzedawcach i zasobach w jednym miejscu. Zamiast skakać między rozproszonymi stronami, możesz korzystać z uporządkowanych zasobów, aby odkrywać informacje, porównywać opcje i sprawniej kontynuować badania.',
  article_p_2:
    'Pomyśl o tym jak o mapie badań: grupuje powiązane elementy, abyś szybko zobaczył, co jest dostępne, porównał szczegóły i zdecydował, gdzie szukać dalej. Sam arkusz to sposób porządkowania informacji, a aktualne produkty i ceny znajdują się na stronie głównej.',

  article_h2_2: 'Dlaczego warto korzystać z USFans Spreadsheet?',
  article_p_3:
    'Ludzie używają arkuszy, aby oszczędzać czas i zachować porządek. Gdy badasz wiele produktów lub sprzedawców naraz, uporządkowany układ pomaga porównywać opcje bez gubienia się w tym, co już sprawdziłeś.',
  article_li_1: 'Organizuj wiele produktów i kategorii w jednym widoku',
  article_li_2: 'Porównuj produkty, sprzedawców i zasoby obok siebie',
  article_li_3: 'Trzymaj notatki z badań w jednym, spójnym miejscu',
  article_li_4: 'Szybciej przechodź od badań do strony głównej',

  article_h2_3: 'Jak korzystać z USFans Spreadsheet (krok po kroku)',
  article_step_1_title: 'Wybierz kategorię',
  article_step_1_desc: 'Zacznij od kategorii, takiej jak Buty, Koszulki lub Torby, aby zawęzić badania.',
  article_step_2_title: 'Porównaj opcje',
  article_step_2_desc: 'Spójrz na różne pozycje i zanotuj szczegóły, które są dla Ciebie ważne.',
  article_step_3_title: 'Zweryfikuj informacje',
  article_step_3_desc: 'Zawsze niezależnie sprawdzaj linki, sprzedawców i szczegóły produktów.',
  article_step_4_title: 'Przejdź do strony głównej',
  article_step_4_desc: 'Gdy będziesz gotowy, kliknij linki, aby przejść dalej na stronę główną.',

  article_h2_4: 'Szybkie porównanie',
  article_compare_col_feature: 'Funkcja',
  article_compare_col_a: 'Badanie arkusza',
  article_compare_col_b: 'Badanie sprzedawcy',
  article_cr1_label: 'Głębokość informacji',
  article_cr1_a: 'Wysoka',
  article_cr1_b: 'Średnia',
  article_cr2_label: 'Łatwość użycia',
  article_cr2_a: 'Łatwa',
  article_cr2_b: 'Umiarkowana',
  article_cr3_label: 'Najlepsze do',
  article_cr3_a: 'Porównywania produktów',
  article_cr3_b: 'Weryfikacji sprzedawców',

  article_h2_5: 'Wskazówki bezpieczeństwa',
  article_p_4:
    'Przed skorzystaniem z arkusza, linku produktu czy informacji o sprzedawcy poświęć chwilę na weryfikację źródła. Kilka prostych nawyków pomoże uniknąć typowych błędów.',
  article_safe_1: 'Weryfikuj linki przed kliknięciem lub zakupem',
  article_safe_2: 'Nigdy nie udostępniaj haseł ani poufnych danych osobowych',
  article_safe_3: 'Uważaj na nieoficjalne strony kopiujące prawdziwą markę',
  article_safe_4: 'Sprawdzaj ceny, wysyłkę i dostępność na stronie głównej',

  article_h2_6: 'Często zadawane pytania',
  article_faq_q1: 'Czy USFans Spreadsheet jest darmowy?',
  article_faq_a1:
    'Korzystanie z uporządkowanego arkusza jako pomocy w badaniach jest bezpłatne. Aktualne ceny produktów, wysyłka i dostępność są pokazane na stronie głównej.',
  article_faq_q2: 'Gdzie znajdę najnowsze produkty?',
  article_faq_a2:
    'Najbardziej aktualne produkty i ceny znajdują się na stronie głównej. Skorzystaj z kategorii, aby przejść bezpośrednio do potrzebnej sekcji.',
  article_faq_q3: 'Czy potrzebuję konta?',
  article_faq_a3:
    'Do przeglądania zasobów tutaj konto nie jest wymagane. Strona główna może mieć własne wymagania.',

  article_cta_title: 'Kontynuuj badanie',
  article_cta_body:
    'Poznaj uporządkowane kategorie i zasoby, a następnie przejdź do strony głównej, gdy będziesz gotowy.',
  article_cta_primary: 'Poznaj USFans Spreadsheet',
  article_cta_secondary: 'Wróć na stronę główną',
  article_not_found: 'Nie znaleziono artykułu',
  article_not_found_desc:
    'Nie mogliśmy znaleźć artykułu, którego szukasz. Przeglądaj nasze poradniki ze strony głównej.',
  article_related: 'Powiązane poradniki',

  article_disclaimer:
    'Zastrzeżenie: USFansLink.boats to niezależne źródło informacji i nie jest oficjalną stroną USFans. Zawsze niezależnie weryfikuj sprzedawców, linki, produkty, ceny, informacje o wysyłce i szczegóły transakcji przed podjęciem decyzji.',
};